import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCreationRequests } from '../hooks/useCreationRequests';
import { REQUEST_STATUS } from '../services/creationRequestService';
import CreationRequestsList from '../components/creation-requests/CreationRequestsList';
import CreationRequestDetail from '../components/creation-requests/CreationRequestDetail';

const STATUS_FILTERS = [
  { value: '', label: 'Toutes' },
  { value: REQUEST_STATUS.NOUVELLE, label: 'Demandes reçues' },
  { value: REQUEST_STATUS.CREATION_EN_COURS, label: 'Création en cours' },
  { value: REQUEST_STATUS.VERIFICATION, label: 'Vérification' },
  { value: REQUEST_STATUS.SITE_PRET, label: 'Sites prêts' },
  { value: REQUEST_STATUS.SITE_PUBLIE, label: 'Sites publiés' }
];

const CreationRequestsPage = () => {
  const location = useLocation();
  const [selected, setSelected] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [closureFilter, setClosureFilter] = useState(''); // '' | 'closedByClient'
  const { requests, isLoading, isError, error } = useCreationRequests(statusFilter, closureFilter);

  // Deep-link : /creation-requests?request=<userId> → ouvre directement la demande
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const requestUserId = params.get('request');
    if (requestUserId) {
      setSelected({ userId: requestUserId });
    }
  }, [location.search]);

  return (
    <div className="max-w-7xl mx-auto p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-primary mb-2">Demandes de création</h1>
        <div className="text-sm breadcrumbs text-base-content/60">
          <ul>
            <li>MSD Admin</li>
            <li>Demandes</li>
          </ul>
        </div>
      </div>

      <div className="bg-base-100 rounded-lg shadow-sm p-6">
        {selected ? (
          <CreationRequestDetail
            userId={selected.userId}
            onBack={() => setSelected(null)}
            key={selected.userId}
          />
        ) : (
          <>
            <div className="flex gap-2 mb-4 flex-wrap">
              {STATUS_FILTERS.map((filter) => (
                <button
                  key={filter.value}
                  type="button"
                  onClick={() => {
                    setStatusFilter(filter.value);
                    setClosureFilter('');
                  }}
                  className={`btn btn-sm ${statusFilter === filter.value && !closureFilter ? 'btn-primary' : 'btn-ghost'}`}
                >
                  {filter.label}
                </button>
              ))}
              <button
                type="button"
                onClick={() => {
                  setClosureFilter(closureFilter === 'closedByClient' ? '' : 'closedByClient');
                  setStatusFilter('');
                }}
                className={`btn btn-sm ${closureFilter === 'closedByClient' ? 'btn-primary' : 'btn-ghost'}`}
              >
                ✓ Clôturées par le client
              </button>
            </div>
            <CreationRequestsList
              requests={requests}
              isLoading={isLoading}
              isError={isError}
              error={error}
              selectedId={selected?.userId}
              onSelect={setSelected}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CreationRequestsPage;
